module.exports = __webpack_public_path__ + "static/LSH_Logo_Greyscale_RGB-9987e47c0a6d6598587f3ce6c014d09e.png";